import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { useTemplateColors } from 'PDF/TemplateEngine/TemplateColorsContext';

// Body type 'stat-strip': fila de tarjetas métricas. config: { stats: [...] }.
function StatStripSection({ section, data }) {
  const { colors, FONT } = useTemplateColors();
  const stats = Array.isArray(section?.config?.stats) ? section.config.stats : [];
  const styles = StyleSheet.create({
    strip: { flexDirection: 'row', gap: '0.25cm' },
    card: {
      flex: 1,
      border: `1px solid ${colors.border}`,
      borderRadius: 8,
      paddingVertical: '0.25cm',
      paddingHorizontal: '0.3cm',
    },
    value: { fontSize: 16, fontFamily: FONT.bold, color: colors.ink || colors.darkText },
    label: { fontSize: 8, fontFamily: FONT.base, color: colors.muted, marginTop: '0.08cm' },
  });
  const resolve = (s) => (s.valueKey ? data?.[s.valueKey] : s.value);
  return (
    <View style={styles.strip}>
      {stats.map((s, i) => (
        <View key={i} style={styles.card}>
          <Text style={styles.value}>{String(resolve(s) ?? '—')}</Text>
          <Text style={styles.label}>{s.label}</Text>
        </View>
      ))}
    </View>
  );
}

export default StatStripSection;
